import { object, string, InferType } from 'yup'

import { isValidCpf } from '../utils/cpf'
import { hasSequentialChars } from '../utils/sequential'

const namePattern = /^(?=.*\p{L})[\p{L}\s'-]+$/u

const schema = object({
  driverName: string()
    .max(50, 'fieldMaxLength')
    .required('requiredField')
    .test('not-only-spaces', 'requiredField', (value) => !!value?.trim())
    .test('no-edge-spaces', 'edgeSpacesField', (value) => !!value && value === value.trim())
    .min(3, 'fieldMinLength')
    .test('sequential', 'sequentialField', (value) => !value || !hasSequentialChars(value))
    .matches(namePattern, 'invalidField')
    .default(''),
  licensePlate: string()
    .max(8, 'fieldMaxLength')
    .required('requiredField')
    .test('not-only-spaces', 'requiredField', (value) => !!value?.trim())
    .test('no-edge-spaces', 'edgeSpacesField', (value) => !!value && value === value.trim())
    .min(3, 'fieldMinLength')
    .test('sequential', 'sequentialField', (value) => !value || !hasSequentialChars(value))
    .test('has-identifier', 'invalidField', (value) => !!value && /[\p{L}\d]/u.test(value))
    .default(''),
  driverSignature: string().required().default(''),
  driverDocument: string()
    .required('requiredField')
    .test('not-only-spaces', 'requiredField', (value) => !!value?.trim())
    .test('no-edge-spaces', 'edgeSpacesField', (value) => !!value && value === value.trim())
    .test('sequential', 'sequentialField', (value) => !value || !hasSequentialChars(value))
    .test('charset', 'invalidField', (value) => !value || /^[\p{L}\d.-]+$/u.test(value))
    .test('no-letters', 'invalidField', (value) => !value || !/\p{L}/u.test(value))
    .test('cpf', 'invalidCpf', (value) => !!value && isValidCpf(value))
    .default('')
})

export type Driver = InferType<typeof schema>

export default schema
